package br.com.heyagenda.web

import kotlinx.browser.window
import org.w3c.dom.url.URLSearchParams

sealed interface WebRoute {
    data object Home : WebRoute
    data class Booking(val slug: String) : WebRoute
}

object WebRouter {

    fun getCurrentRoute(): WebRoute {
        // 1. Check query parameter '?p=...' or '?slug=...'
        val search = window.location.search
        if (search.isNotBlank()) {
            val params = URLSearchParams(search)
            val p = params.get("p") ?: params.get("slug") ?: params.get("pro")
            if (!p.isNullOrBlank()) {
                return WebRoute.Booking(p.trim().trim('/'))
            }
        }

        // 2. Check hash route '#/slug' or '#slug'
        val hash = window.location.hash
        if (hash.isNotBlank() && hash != "#" && hash != "#/") {
            val cleanedHash = hash.removePrefix("#").removePrefix("/").trim()
            if (cleanedHash.isNotBlank()) {
                return WebRoute.Booking(cleanedHash)
            }
        }

        // 3. Check pathname '/slug'
        val path = window.location.pathname.trim('/')
        if (path.isNotBlank() && path != "index.html" && path != "404.html") {
            val segment = path.split('/').firstOrNull().orEmpty().trim()
            if (segment.isNotBlank()) {
                return WebRoute.Booking(segment)
            }
        }

        return WebRoute.Home
    }

    fun navigateTo(route: WebRoute) {
        try {
            when (route) {
                is WebRoute.Home -> {
                    window.history.pushState(null, "", "/")
                }
                is WebRoute.Booking -> {
                    window.history.pushState(null, "", "/${route.slug}")
                }
            }
        } catch (_: Throwable) {}
    }
}
